var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMove = function SvgIconMove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    d: "M6.067 4.95c-.504 0-.756-.6-.4-.952L9.1.613a.57.57 0 0 1 .8 0l3.433 3.385c.357.352.104.952-.4.952z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    d: "M6.067 14.95c-.504 0-.756.6-.4.952L9.1 19.287c.221.218.579.218.8 0l3.433-3.385c.357-.351.104-.952-.4-.952H11v-3.5h3.5v1.934c0 .503.6.756.952.4l3.385-3.434a.57.57 0 0 0 0-.8l-3.385-3.433c-.351-.356-.952-.104-.952.4V8.45H11v-3.5H8v3.5H4.5V6.517c0-.504-.6-.756-.952-.4L.163 9.55a.57.57 0 0 0 0 .8l3.385 3.433c.351.357.952.104.952-.4V11.45H8v3.5z"
  })));
};
export default SvgIconMove;